module.exports = __webpack_public_path__ + "static/media/4cocci2rods.669d78d8.jpg";